<script>
    export let fill = '#000'
</script>

<style>
    svg {
        position: absolute;
        top: 385px;
        right: 15px;
        width: 152.28px;
        height: 23.69px;
    }
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 152.28 23.69">
    <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
            <path
                {fill}
                d="M94.27,20.88a12.89,12.89,0,0,0,13-13c0-.2,0-.4,0-.59a9.3,9.3,0,0,0,2.27-2.37,8.76,8.76,0,0,1-2.62.72,4.54,4.54,0,0,0,2-2.52A9.33,9.33,0,0,1,106,4.25a4.56,4.56,0,0,0-7.89,3.12,4.48,4.48,0,0,0,.12,1,13,13,0,0,1-9.41-4.77,4.56,4.56,0,0,0,1.41,6.09,4.47,4.47,0,0,1-2.06-.57.13.13,0,0,0,0,.06,4.56,4.56,0,0,0,3.67,4.47,4.42,4.42,0,0,1-1.21.16,4.11,4.11,0,0,1-.86-.08A4.58,4.58,0,0,0,94,16.94a9.12,9.12,0,0,1-5.67,2,9.81,9.81,0,0,1-1.09-.07,12.88,12.88,0,0,0,7,2.05"
            />
            <path
                {fill}
                d="M57.33,4.57a.41.41,0,0,0-.4,0l-7,4a.38.38,0,0,0-.11.11H47.23A1.16,1.16,0,0,0,46.07,9.9v3.52a1.17,1.17,0,0,0,1.16,1.17H50l6.95,4.52a.43.43,0,0,0,.22.06.32.32,0,0,0,.19-.05.39.39,0,0,0,.21-.35V4.92A.38.38,0,0,0,57.33,4.57Z"
            />
            <line {fill} x1="59.79" y1="11.84" x2="64.37" y2="11.84" />
            <line {fill} x1="59.79" y1="14.36" x2="63.76" y2="16.65" />
            <line {fill} x1="59.79" y1="9.32" x2="63.76" y2="7.03" />
            <path
                {fill}
                d="M147,3.16,143.86,0,128.6,15.26l3.16,3.16a1.49,1.49,0,0,1,2.1,2.11L137,23.69,152.28,8.42l-3.15-3.16A1.49,1.49,0,1,1,147,3.16ZM132.28,14.74,136,11.05l1.58,1.58-3.69,3.69Zm2.11,2.1,3.68-3.68.53.53-3.69,3.68Zm1.05,1.06,3.69-3.69,1.05,1L136.49,19Zm5.79-1.58L137.55,20l-.53-.52,3.68-3.69Zm2.63-1.58-.52.52-6.85-6.84L137,7.9Zm1-4.43-1-1-1,1-1.27-1.28,1-1-1-1,3.87-.65Z"
            />
            <path
                {fill}
                d="M16.2,7.46V7.18a2.7,2.7,0,0,0-2.68-2.69H2.68A2.7,2.7,0,0,0,0,7.18v9A2.7,2.7,0,0,0,2.68,18.9H13.46a2.73,2.73,0,0,0,2.74-2.67Zm-4,4.42L5.82,15.55a.23.23,0,0,1-.14,0,.25.25,0,0,1-.14,0,.27.27,0,0,1-.14-.24V8a.29.29,0,0,1,.14-.25.28.28,0,0,1,.28,0l6.36,3.67a.29.29,0,0,1,.14.25A.27.27,0,0,1,12.18,11.88Z"
            />
            <polygon {fill} points="17.1 15.6 21.6 17.37 21.6 5.91 17.1 7.67 17.1 15.6" />
            <rect {fill} x="22.5" y="5.91" width="0.9" height="11.46" />
        </g>
    </g></svg>
